

import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { useSearchParams } from "react-router-dom";
import { resolvePurchaseToken, activateSubscription } from "../api/requests";
import { useEffect } from "react";

export function SubscriptionDetailsCard({ data, onActivate }) {

  return (
    <Paper elevation={0} className="paper">
      {/* Customer Email */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Customer Email</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.customerEmail}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Customer Name */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Customer Name</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.customerName}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* ID */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">ID</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value mono">{data.id}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Name */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Name</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.name}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Status */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Status</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.status}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Plan */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Plan</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.plan}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Purchaser Email */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Purchaser Email</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value">{data.purchaserEmail}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />

      {/* Azure Tenant ID */}
      <Grid container alignItems="center" spacing={2} className="details-row">
        <Grid item xs={12} sm={4} md={3}>
          <Typography variant="body2" className="label">Azure Tenant ID</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography variant="body1" className="value mono">{data.azureTenantId}</Typography>
        </Grid>
      </Grid>
      <Divider className="divider" />


      <Box className="coupon-actions">
        <Button variant="contained" onClick={onActivate} className="activate" disabled={data?.status === "activated"}>
          Activate
        </Button>
      </Box>
    </Paper>
  );
}

export default function SubscriptionDetailsPage() {
  const [loading, setLoading] = useState(false);
  const [activating, setActivating] = useState(false);
  const [searchParams] = useSearchParams();
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const fetchSubscription = async () => {
      setLoading(true);

      const msaSubscriptionToken = searchParams.get("token");

      if (!msaSubscriptionToken ) {
        // throw new Error("Missing MSA subscription token");
        setLoading(false);
      }
      
      try {
        const details = await resolvePurchaseToken(msaSubscriptionToken);
        setSubscription(details);
      } catch (err) {
        console.error("Resolve failed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [searchParams]);

  const handleActivate = async () => {
    if (!subscription) return;
    setActivating(true);
    try {
      const res = await activateSubscription(subscription.id);
      console.log("Activation response:", res);
      setSubscription({ ...subscription, status: "activated" });
    } catch (err) {
        console.error("Activation failed:", err);
        setSubscription({ ...subscription, status: "failed" });
    } finally {
      setActivating(false);
    }
  };


  return (
      <Stack display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} spacing={2} mt={10} >
        <Stack direction={"row"}  spacing={2}justifyContent={"left"} width={"100%"}>
        <Typography variant="h6" className="section-title">
          SUBSCRIPTION DETAILS
        </Typography>
        </Stack>
    <Box className="body-bg" width={"1000px"}>
      <Styles />
      <Container maxWidth="md" className="container">
          <Stack sx={{ width: "100%", maxWidth: 1000 }}>
              {loading && <CircularProgress />}
              {!loading && !!subscription && (
                <SubscriptionDetailsCard
                  data={subscription}
                  onActivate={handleActivate}
                />
              )}
              {!loading && !subscription && (
                <Typography variant="body1" align="center">
                  No subscription found. Missing or invalid token.
                </Typography>
              )}
            </Stack>
      </Container>
    </Box>
            {activating && <Typography>Activating subscription…</Typography>}
            {subscription?.status === "failed" && !activating && <Typography>Error activating subscription. Please try again.</Typography>}
            {subscription?.status === "activated" && <Typography>Subscription activated successfully!</Typography>}
    </Stack>
  );
}

function Styles() {
  return (
    <style>{`
      .body-bg { background: #f5f7fb; }
      .appbar { background: #186fb5; }
      .toolbar { display: flex; justify-content: space-between; }
      .title { font-weight: 600; letter-spacing: 0.4px; }
      .user-box { display: flex; align-items: center; gap: 12px; }
      .avatar { width: 28px; height: 28px; background: #135a92; }
      .header-name { font-weight: 600; }
      .container { padding-top: 40px; padding-bottom: 40px; }
      .section-title { margin-bottom: 20px; font-weight: 700; color: #274b6d; letter-spacing: 1px; }
      .paper { padding: 32px; border-radius: 8px; background: #ffffff; border: 1px solid #e8edf3; }
      .divider { margin: 10px 0; }
      .details-row { padding-top: 4px; padding-bottom: 4px; }
      .label { color: #5d7186; font-weight: 600; }
      .value { color: #1c2b36; word-break: break-word; }
      .mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
      .coupon-actions { display: flex; justify-content: flex-end; margin-top: 24px; }
      .activate { min-width: 120px; }
    `}</style>
  );
}